export const NAME_SPACE:string = 'com.keethings';
export const MODULE_NAME: string = 'Core Module';
export const MODULE_CLASS_NAME = 'CoreModule';
export const SINGLETON_CLASS: string = 'Class is a singleton. Use .get() method to return an instance.';

export enum Platforms {
    WEB='web',
    NATIVE='native'
}

//EXCEPTIONS =======================
export const METHOD_NOT_IMPL: string = 'Method not implemented.';
export const METHOD_TO_BE_IMPL_ON_CLIENT: string = 'Method to be implemented on client.';
export const SERVICE_REMOTE_CALL_EXCEPTION:string = 'service-remote-call-exception';
export const SERVICE_EXCEPTION:string = 'service-exception';
export const TYPE_ERROR:string='TypeError';


